// Regras de autorização do módulo de Células no frontend — espelha
// backend/src/modules/cells/cells.authorization.ts (mesmos nomes de role
// seedados no banco: ADMIN, PRESBITERO, LIDER).
const ADMIN_ROLES = ['ADMIN'];
const PRESBYTER_ROLES = ['PRESBITERO', 'PASTOR', 'SUPERVISOR'];
const CELL_LEADER_ROLES = ['LIDER'];

export function isAdmin(user) {
  return ADMIN_ROLES.includes(user?.role);
}

export function isPresbyter(user) {
  return PRESBYTER_ROLES.includes(user?.role);
}

export function isCellLeader(user) {
  return CELL_LEADER_ROLES.includes(user?.role);
}

export function canCreateCell(user) {
  return isAdmin(user) || isPresbyter(user);
}

export function canViewCell(user, cell) {
  if (!user) return false;
  if (isAdmin(user)) return true;
  if (isPresbyter(user)) return (user.networkIds || []).includes(cell.networkId);
  if (isCellLeader(user)) return user.cellId === cell.id;
  return false;
}

export function canEditCell(user, cell) {
  return canViewCell(user, cell);
}

export function canDeleteCell(user) {
  return isAdmin(user);
}

// Redes que o usuário pode atribuir/mover uma célula para.
export function assignableNetworks(user, networks) {
  if (isAdmin(user)) return networks;
  if (isPresbyter(user)) return networks.filter((n) => (user.networkIds || []).includes(n.id));
  return networks;
}
